module.exports = __webpack_public_path__ + "img/ios.65870d52.png";